import React, { useEffect } from "react";
import NewNavigation from "../components/NewNavigation";
import NewHero from "../components/NewHero";
import NewServices from "../components/NewServices";
import NewAbout from "../components/NewAbout";
import NewWhyChooseUs from "../components/NewWhyChooseUs";
import NewWorkProcess from "../components/NewWorkProcess";
import NewContact from "../components/NewContact";
import NewFooter from "../components/NewFooter";

const Home = () => {
  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (badge) badge.remove();
    document.title = "Evershinetiling Services";
    const svg = `
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <polygon points="50,10 90,30 90,70 50,90" fill="#3B82F6"/>
      <polygon points="50,10 10,30 10,70 50,90" fill="#2563EB"/>
      <polygon points="10,30 50,50 90,30 50,10" fill="#60A5FA"/>
    </svg>
  `;
    const faviconUrl = "data:image/svg+xml," + encodeURIComponent(svg);
    let link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.parentNode.removeChild(link);
    }
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <NewNavigation />
      <NewHero />
      <NewServices />
      <NewAbout />
      <NewWhyChooseUs />
      <NewWorkProcess />
      <NewContact />
      <NewFooter />
    </div>
  );
};

export default Home;
